import React, { Suspense, lazy } from 'react';
import { Box, Link } from '@chakra-ui/react';
import TopBar from './TopBar';
import Navbar from './Navbar';
import Footer from './Footer';
import WhatsAppButton from './WhatsAppButton';
import Seo from './Seo';

const SiesaAppPromoToast = lazy(() => import('../ui/SiesaAppPromoToast'));

export default function Layout({
  title,
  description,
  image,
  whatsappMessage,
  seoChildren,
  children,
}) {
  return (
    <Box minH="100vh" w="100%" maxW="100vw" overflowX="hidden" position="relative">
      <Seo title={title} description={description} image={image}>
        {seoChildren}
      </Seo>

      <Link
        href="#contenido"
        position="absolute"
        left="-9999px"
        zIndex="skipLink"
        bg="brand.700"
        color="white"
        px={4}
        py={3}
        _focus={{ left: 4, top: 4 }}
      >
        Saltar al contenido
      </Link>

      <TopBar />
      <Navbar />

      <Box as="main" id="contenido" tabIndex={-1} outline="none" w="100%">
        {children}
      </Box>

      <Footer />
      <WhatsAppButton message={whatsappMessage} />
      <Suspense fallback={null}>
        <SiesaAppPromoToast />
      </Suspense>
    </Box>
  );
}
